<template>
  <div class="pc-vidoe-box">
    <video id="pc-video-player_html5_api" class="pc-video-player-html5-api"
      preload="auto" controls="true"
      poster="https://mediakit.enabot.com/eboX/img/pc/pc_video_home.png"
      src="https://mediakit.enabot.com/eboX/video/EBOXweb.mp4">
    </video>
    <img class="pc-videoIcon" src="https://mediakit.enabot.com/eboX/img/pc/PCVideo.png" alt="" @click="PCPlayFn" v-if="PCtype">
  </div>
</template>

<script>
export default {
  data() {
    return {
      PCtype:true,
      PCPlayer:null
    }
  },
  mounted() {
    this.PCPlayer = document.getElementById("pc-video-player_html5_api");
    // this.phonePlayer.pause()
    //该视频播放是否已结束
    this.PCPlayer.addEventListener('ended', this.handleEnded, false)
    this.PCPlayer.addEventListener('play', this.handlePlay, false)
    this.PCPlayer.addEventListener('pause', this.handlePause, false)
  },
  methods: {
    PCPlayFn() {
      this.PCtype = false
      this.$nextTick(() => {
        if(window.gtag){
          window.gtag('event', 'click_play_button', {
            'event_category': 'button',
            'event_label': '点击按钮播放视频次数',
          });
        }
        this.PCPlayer.play();
      })
    },
    handleEnded() {
      this.PCtype = true
      this.PCPlayer.load()
    },
    handlePlay() {
      this.PCtype = false
      this.PCPlayer.play()
      if(window.gtag){
        window.gtag('event', 'click_native_play', {
          'event_category': 'play',
          'event_label': '视频播放次数',
        });
      }
    },
    handlePause() {
      this.PCtype = true
      this.PCPlayer.pause()
    }
  },
}
</script>

<style lang="scss">
.pc-vidoe-box{
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 400px;
  img{
    width: 100%;
  }
  .pc-video-player-html5-api{
    width: 100%;
    height: auto;
    min-height: 12rem;
  }
  .pc-videoIcon{
    position: absolute;
    width: 17%;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    cursor: pointer;
    z-index: 4;
  }
}
</style>